import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CurrencyBtc, X, ShieldCheck, ArrowSquareOut } from "@phosphor-icons/react";

// Reusable inline tax blurb for donation forms
export const CryptoTaxBlurb = () => (
    <p className="text-xs text-foreground/55 leading-relaxed" data-testid="crypto-tax-blurb">
        <strong className="text-foreground/70">Give crypto, tax-efficiently.</strong> Donating appreciated crypto directly may let you
        avoid capital-gains tax and deduct the full fair-market value. <em>Not tax advice — consult your tax advisor.</em>
    </p>
);

export const CryptoDonateButton = ({ orgId, orgName = "this nonprofit", compact = false }) => {
    const [enabled, setEnabled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!orgId) return;
        api.get(`/crypto/public/${orgId}`).then(r => setEnabled(!!r.data?.enabled)).catch(() => {});
    }, [orgId]);

    if (!enabled) return null;

    return (
        <>
            <button type="button" onClick={() => setOpen(true)} data-testid="donate-crypto-btn"
                className={`inline-flex items-center justify-center gap-2 rounded-full border border-accent text-accent hover:bg-accent hover:text-accent-foreground transition-colors font-semibold ${compact ? "px-4 py-2 text-sm" : "w-full px-6 py-3"}`}>
                <CurrencyBtc size={18} weight="bold" /> Donate with Crypto
            </button>

            {open && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 p-4" onClick={() => setOpen(false)} data-testid="crypto-modal">
                    <div className="relative w-full max-w-md rounded-2xl bg-card p-7 shadow-xl" onClick={e => e.stopPropagation()}>
                        <button onClick={() => setOpen(false)} className="absolute top-4 right-4 text-muted-foreground hover:text-foreground" data-testid="crypto-modal-close"><X size={20} /></button>
                        <div className="flex items-center gap-2 text-accent"><CurrencyBtc size={26} weight="bold" />
                            <h3 className="font-heading text-2xl text-foreground">Donate crypto</h3>
                        </div>
                        <p className="mt-2 text-sm text-foreground/70">
                            Support {orgName} with USDC and popular cryptocurrencies. Your donation is securely processed and
                            <strong> automatically converted to USD</strong> by our regulated crypto partner — so the nonprofit never holds volatile assets.
                        </p>
                        <div className="mt-4 rounded-lg bg-accent/5 border border-accent/20 p-4">
                            <CryptoTaxBlurb />
                        </div>
                        <div className="mt-5" data-testid="crypto-widget-slot">
                            {/* Phase 2: the crypto processor's widget/checkout mounts here once org is connected */}
                            <button className="btn-accent w-full" data-testid="crypto-continue">Continue to secure crypto checkout</button>
                            <p className="mt-3 flex items-center justify-center gap-1.5 text-[11px] text-foreground/45">
                                <ShieldCheck size={13} /> Securely processed · funds settle in USD
                            </p>
                        </div>
                        <a href="/crypto-donations" className="mt-4 flex items-center justify-center gap-1 text-xs text-accent hover:underline" data-testid="crypto-learn-more">
                            Learn about crypto giving & tax benefits <ArrowSquareOut size={12} />
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};
